
import React from 'react';
import { useGA4ViewEvent } from '../../../hooks/useGA4';

const benefits = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: '収入を維持しながら夜勤を減らせる',
    desc: '一般企業（産業看護師）や美容クリニックなど、高単価な日勤案件を独自データでマッチング。お給料を下げることなく、夜勤を減らす働き方が実現できます。',
  },
  {
    icon: 'ri-bar-chart-box-line',
    title: 'データに基づいた最適な提案',
    desc: '膨大な求人データの中から、あなたの経験・スキル・希望条件にぴったり合う案件を厳選。無理のない転職プランをご提案します。',
  },
];

export default function BenefitsSection() {
  const sectionRef = useGA4ViewEvent('nijikango04_view_benefit');

  return (
    <section ref={sectionRef} id="section-benefit" className="py-12 px-5 bg-pink-50">
      <h2 className="text-[22px] font-bold text-center text-gray-900 mb-3 leading-[1.5]">
        お給料を維持したまま、<br />夜勤を少なくすることも可能です。
      </h2>
      <p className="text-center text-[13px] text-gray-500 mb-10">
        あなたの価値は、夜勤の有無では変わりません
      </p>

      <div className="space-y-4">
        {benefits.map((item) => (
          <div key={item.title} className="bg-white rounded-2xl p-6 shadow-sm">
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-[16px] font-bold text-gray-900">{item.title}</h3>
            </div>
            <p className="text-[13px] text-gray-600 leading-[1.8]">{item.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
